<template>
  <div class="BallLogo">
    <svg
      width="38"
      height="38"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        class="BallLogo__outline"
        d="M46 23C46 10.2975 35.7025 0 23 0C10.2975 0 0 10.2975 0 23C0 35.7025 10.2975 46 23 46C35.7025 46 46 35.7025 46 23Z"
        fill="var(--outlineColor)"
      />
      <path
        d="M23 4C33.4934 4 42 12.5066 42 23C42 33.4934 33.4934 42 23 42C12.5066 42 4 33.4934 4 23C4 12.5066 12.5066 4 23 4Z"
        fill="var(--iconColor, var(--colorOrange))"
        stroke="var(--colorOffBlack)"
        stroke-width="2"
      />
      <path
        d="M23 4C23.3354 4 23.6688 4.00822 24 4.02539V22H27.0322C27.3868 16.25 30.7774 11.3211 35.6211 8.79883C36.1487 9.26804 36.6506 9.76542 37.123 10.29C32.6137 12.3788 29.4034 16.7967 29.0361 22H41.9746C41.9918 22.3312 42 22.6646 42 23C42 23.3354 41.9918 23.6688 41.9746 24H29.0361C29.4034 29.2031 32.6139 33.6201 37.123 35.709C36.6506 36.2336 36.1487 36.7309 35.6211 37.2002C30.7776 34.6778 27.3868 29.7498 27.0322 24H24V41.9736C23.6688 41.9908 23.3354 42 23 42C22.6646 42 22.3312 41.9908 22 41.9736V24H18.9678C18.6131 29.7501 15.2219 34.6779 10.3779 37.2002C9.85039 36.7309 9.34838 36.2336 8.87598 35.709C13.3856 33.6203 16.5966 29.2034 16.9639 24H4.02539C4.00822 23.6688 4 23.3354 4 23C4 22.6646 4.00822 22.3312 4.02539 22H16.9639C16.5966 16.7964 13.3858 12.3787 8.87598 10.29C9.34838 9.76542 9.85039 9.26804 10.3779 8.79883C15.2221 11.321 18.6131 16.2497 18.9678 22H22V4.02539C22.3312 4.00822 22.6646 4 23 4Z"
        fill="var(--colorOffBlack)"
      />
    </svg>
  </div>
</template>

<script lang="ts" setup>
</script>

<style lang="scss" scoped>
.BallLogo {
  --outlineColor: var(--themeLightTransparent700);

  .router-link-active & {
    --outlineColor: var(--themeColorNeutral0);
  }
}

.BallLogo__outline {
  transition: 350ms fill;
}
</style>
